import { useNavigate, useParams } from 'react-router-dom';
import { V2CloseButton } from '@sakhtar/design-system/react';
import { tenantBasePath } from '../lib/tenant.js';
import './mobileOverlays.css';

/**
 * Header of a routed mobile page (/mobile/menu, /notifications, /add, /tasks):
 * these open as whole screens from the bottom bar, so they need an obvious
 * close — it goes back, or home when the page was opened directly.
 */
export function MobilePageHead({ title }: { readonly title: string }) {
  const navigate = useNavigate();
  const { slug } = useParams<{ slug: string }>();
  const close = () => {
    if (window.history.length > 1) navigate(-1);
    else if (slug) navigate(tenantBasePath(slug));
  };
  return (
    <div className="sk-mobile-page-head">
      <span className="sk-mobile-page-head__title">{title}</span>
      <V2CloseButton onClick={close} />
    </div>
  );
}
